import React from "react"
import clsx from "clsx"
import { useTranslation } from "react-i18next"

import { Switch } from "components"
import classes from "./SsSwitch.module.scss"

const SsSwitch = props => {
  const { text, value, onClick } = props

  const i18n = useTranslation()[1]

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div className={classes["row"]}>
      <div
        className={clsx(
          classes["text"],
          isLtr && classes["text-ltr"]
        )}
      >
        {text}
      </div>

      <Switch
        onClick={onClick}
        checked={!!value}
      />
    </div>
  )
}

export default SsSwitch